import React, { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import AccountIdBox from "../../AccountIdBox";
import CustomConversions from "./CustomConversions";
import CustomTooltip from "utils/CustomTooltip";
import ManualDataPull from "client_config/ManualDataPull";
import CurrencySelector from "client_config/CurrencySelector";
import jsDig from "utils/jsDig.js";
import { capitalize } from "lodash";

export default function IdsData(props) {
  let thumbnail = require("images/ShowMeHow.jpg");
  thumbnail = <img className="thumbnail" src={`/datapulse${thumbnail}`} />;
  let platforms = [
    {
      name: "facebook_ads",
      id: "pull-social-facebook",
      label: "Pull Facebook Ads on save",
    },
    {
      name: "tiktok_ads",
      id: "pull-social-tiktok",
      label: "Pull TikTok Ads on save",
    }
  ];
  const [conversionObjective, setConversionObjective] = useState(props.social_section.conversion_objective);
  const [tiktokConversionObjective, setTiktokConversionObjective] = useState(props.social_section.tiktok_conversion_objective);

  const [baseCurrency, setBaseCurrency] = useState(props.social_section.base_currency)
  const [displayCurrency, setDisplayCurrency] = useState(props.social_section.display_currency)

  return (
    <div className="ml-0 ml-md-3 p-3">
      <Row className="py-4 px-3 px-md-4 justify-content-between">
        <Col className="" xs={12} lg={6}>
        <div className="">
            <div>
              <p className="f18 text-info d-inline-block visby-bold">Account IDs </p>
              <CustomTooltip
                faClass="far text-info fa-question-circle pl-2"
                message="List your account IDs below for the specified platforms. This is how we will pull metrics into DataPulse, so it’s important that your IDs match exactly."
                inline={true}
              />
            </div>
            <div className="py-4">
              <AccountIdBox
                platformId="social-facebook-ads-id"
                platformName="Facebook Ads"
                platformData={jsDig(["facebook_ads"], props.social_section.platform_data)}
                fieldName="[platform_data][social][facebook_ads]"
              />
            </div>
            <div className="py-4">
              <AccountIdBox
                platformId="social-tiktok-ads-id"
                platformName="Tiktok Ads"
                platformData={jsDig(["tiktok_ads"], props.social_section.platform_data)}
                fieldName="[platform_data][social][tiktok_ads]"
              />
            </div>
            
          </div>
        </Col>
        <Col className="px-0 px-md-3" xs={12} lg={6}>
          <ManualDataPull isEnabled={props.social_section.data_pull_enabled} platforms={platforms} service="social" />
          <div className="ml-0 ml-md-3" style={{ display: "flex", flexDirection: "column" }}>
            <span className="d-inline-block visby-bold primary f16 mt-3 mb-1">
              Filter account data{" "}
              <CustomTooltip
                faClass="far f16 primary fa-question-circle pl-2"
                message="Fill out this field to only pull social data from campaigns where the names contain the text provided. Leave this field blank to pull all data."
                inline={true}
              />
            </span>

            <Form.Control
              className="d-inline"
              size="sm"
              style={{ maxWidth: "370px" }}
              name="pull_campaign_name_only"
              defaultValue={props.social_section.pull_campaign_name_only}
              placeholder="leave blank for all data or eg. (DP) for specific campaigns"
            />
          </div>
        </Col>
      </Row>
      <Row className="py-2 px-0 px-md-4">
        <Col>
          <div className="d-flex flex-wrap" style={{gap: "20px"}}>
            <div className="">
              <p className="f18 mb-3 text-info d-inline-block visby-bold"> Facebook Objective </p>
              <CustomTooltip
                faClass="far text-info fa-question-circle pl-2"
                message="Here you can set the objective for facebook conversions. Choose one of the pre-made settings from the dropdown, or use the custom conversions option to be more specific and input your own conversion IDs and labels (labels are simply to make your IDs easier to identify within DataPulse)."
                inline={true}
              />
              <Form.Control
                className="primary mb-2"
                size="md"
                as="select"
                name="[facebook_conversion_objective]"
                value={conversionObjective}
                onChange={(e) => setConversionObjective(e.target.value)}
                style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
                {Object.keys(props.facebook_conversion_objectives).map((objectiveName) => {
                  const objectiveInt = props.facebook_conversion_objectives[objectiveName];
                  return (
                    <option key={objectiveInt} value={objectiveName}>
                      {capitalize(objectiveName.split("_").join(" "))}
                    </option>
                  );
                })}
              </Form.Control>
              {conversionObjective == "custom_conversions" && <CustomConversions customConversions={props.social_section.custom_conversions} />}
            </div>
            
            <div className="tiktok-conversion-objective">
              <p className="f18 mb-3 text-info d-inline-block visby-bold"> Tiktok Objective </p>
              <CustomTooltip
                faClass="far text-info fa-question-circle pl-2"
                message="Choose which objective the Tiktok campaigns are targeting, typically 'Complete payment' for e-commerce and 'Complete registration' for Lead generation."
                inline={true}
              />
              <Form.Control
                className="primary mb-2"
                size="md"
                as="select"
                name="[tiktok_conversion_objective]"
                value={tiktokConversionObjective}
                onChange={(e) => setTiktokConversionObjective(e.target.value)}
                style={{ width: "256px", paddingLeft: "20px", marginLeft: "3px" }}>
                {Object.keys(props.tiktok_conversion_objectives).map((objectiveName) => {
                  const objectiveInt = props.tiktok_conversion_objectives[objectiveName];
                  return (
                    <option key={objectiveInt} value={objectiveName}>
                      {capitalize(objectiveName.split("_").join(" "))}
                    </option>
                  );
                })}
              </Form.Control>
            </div>
          </div>
        </Col>
      </Row>
      <Row className="py-4 px-0 px-md-4">
        <Col xs={12} sm={6}>
          <h5 className="pl-1">Base Currency</h5>
          <CurrencySelector selectedCurrency={baseCurrency} setSelectedCurrency={setBaseCurrency} nameAttribute="social_base_currency" />
        </Col>
        <Col xs={12} sm={6}>
          <h5 className="pl-1">Display Currency</h5>
          <CurrencySelector selectedCurrency={displayCurrency} setSelectedCurrency={setDisplayCurrency} nameAttribute="social_display_currency" />
        </Col>
      </Row>
    </div>
  );
}
